export default {
  message: 'Tin nhắn',
  active: 'Đang hoạt động',
  inactive: 'Không hoạt động',
  isTyping: 'đang gõ',
  people: 'Người',
  groups: 'Nhóm',
  lastLogin: 'Đang nhập lần cuối',
  read: 'đã xem',
  am: 'sáng',
  pm: 'chiều',
  connecting: 'Đang kết nối',
  cannotConnect: 'Không thể kết nối tới server',
  retry: 'Thử lại',
  typeAMessage: 'Nhập tin nhắn',
  sending: 'Đang gửi...'
}
